import type { MANIFEST_SCOPES } from '@xing-com/crate-core-assets';

export const KNOWN_SITES = ['xing', 'lebenslauf', 'xing-login'] as const;
export type Site = (typeof MANIFEST_SCOPES | typeof KNOWN_SITES)[number];

export function detectSite({
  entryPoint,
  manifestScope,
}: {
  entryPoint: string;
  manifestScope: string;
}): Site | undefined {
  if (manifestScope !== 'xing') return undefined;
  if (entryPoint === '@xing-com/crate-communication-root') return 'xing';
  if (entryPoint === '@xing-com/crate-login-root') return 'xing-login';
  if (
    entryPoint === '@xing-com/crate-lebenslauf-root' ||
    entryPoint === '@xing-com/crate-lebenslauf-anschreiben'
  ) {
    return 'lebenslauf';
  }

  return undefined;
}
